import { canRotate, cellIndex, occupants, type Board, type Cell, type Move } from '../puzzle';

export type Selection = { anchor: number } | null;
/** rotate = 点的是旋转块（且没有选中别的块）：转它 90° */
export type TapResult = { selection: Selection; move?: Move; rotate?: number };

export function onTap(board: Board, selection: Selection, tapped: Cell | null): TapResult {
  if (!tapped) return { selection: null };
  const tile = occupants(board)[cellIndex(tapped, board.n)];
  // 没有选中块时点旋转块 = 转它；已经选中了一块时点旋转块 = 照常交换（完成这次点选）
  if (!selection) return canRotate(board, tile) ? { selection: null, rotate: tile } : { selection: { anchor: tile } };
  if (tile === selection.anchor) return { selection: null };
  return { selection: null, move: { anchor: selection.anchor, to: tapped } };
}
